
























































































































































































































import Vue from 'vue'
import Broadcast from '@/types/Broadcast.interface'
import {
    BroadcastSentFilterParams,
    BroadcastFailedFilterParams
} from '@/types/FilterParams.interface'
import { BroadcastParams } from '@/types/PaginationParams.interface'
import Button from '@/types/components/Button.interface'
import FilterButton from '@/components/FilterButton.vue'
import IListAction, { IListActionType } from '@/types/components/IListAction.interface'
import IListIcon, { IListIconType } from '@/types/components/IListIcon.interface'
import IListPlaceholder from '@/types/components/IListPlaceholder.interface'
import IListTile from '@/types/components/IListTile.interface'
import IListTileColumn from '@/types/components/IListTileColumn.interface'
import { mapGetters } from 'vuex'
import Message from '@/types/Message.interface'
import message from '@/mixins/message-mixin'
import MessagePreviewBubble from '@/components/MessagePreviewBubble.vue'
import mixin from '@/mixins/broadcasts-mixin'
import Schedule from '@/types/Schedule.interface'
import ScheduleBuilder from '@/components/ScheduleBuilder.vue'
import ScrollPosition from '@/types/components/ScrollPosition.interface'
import TabPanel from '@/components/TabPanel.vue'
import Group from '@/types/Group.interface'
export default Vue.extend({
    mixins: [mixin, message],
    components: {
        FilterButton,
        MessagePreviewBubble,
        ScheduleBuilder,
        TabPanel
    },
    props: ['id'],
    data: () => ({
        excludeGroups: null,
        excludePersons: null,
        // Determines palceholder message
        filterApplied: null,
        loading: false,
        //  Determines if we have finished loading and mounting
        mounted: false,
        //  Store default message properties (for calculating character length)
        messageConfig: {
            messagePartLimit: 20,
            defaultSMSLength: 160,
            multipartSMSHeaderLength: 7,
            unicodeSMSLength: 70
        },
        //  The broadcasts failed filter
        failedType: {
            selected: {
                display: 'All',
                key: 'failedType',
                value: 'all',
                selected: 'all'
            },
            options: [
                {
                    display: 'All',
                    key: 'failedType',
                    value: 'all'
                },
                {
                    display: 'Failed',
                    key: 'failedType',
                    value: 'failed'
                }
            ]
        },
        persons: null,
        //  The broadcasts sent filter
        sentType: {
            selected: {
                display: 'All',
                key: 'sentType',
                value: 'all',
                selected: 'all'
            },
            options: [
                {
                    display: 'All',
                    key: 'sentType',
                    value: 'all'
                },
                {
                    display: 'Sent',
                    key: 'sentType',
                    value: 'sent'
                },
                {
                    display: 'Delivered',
                    key: 'sentType',
                    value: 'delivered'
                }
            ]
        },
        tabs: [
            {
                color: '#D7BFFF',
                text: 'Message',
                icon: 'bi-megaphone-fill',
                iconColorActive: '#8168C0',
                width: '500px'
            },
            {
                color: '#D7BFFF',
                text: 'Analytics',
                icon: 'bi-bar-chart-line-fill',
                iconColorActive: '#8168C0'
            },
            {
                color: '#D7BFFF',
                text: 'Sent',
                icon: 'bi-send-fill',
                iconColorActive: '#8168C0'
            },
            {
                color: '#D7BFFF',
                text: 'Failure',
                icon: 'bi-exclamation-circle-fill',
                iconColorActive: '#8168C0'
            }
        ],
        toolbar: {
            title: 'Broadcasts',
            left: [
                {
                    title: 'Back',
                    icon: 'mdi-chevron-left',
                    back: '/broadcasts',
                    tooltip: 'Back',
                    permission: 0,
                    feature: null
                }
            ],
            right: []
        }
    }),
    beforeDestroy() {
        //  When leaving, we want to get rid of our selected broadcast messages
        this.$store.commit('broadcastsViewSelectedBroadcastSet', null)

        //  We also want to get rid of our selected broadcast groups
        this.$store.commit('broadcastsViewSelectedGroupsSet', null)
    },
    async mounted() {
        //  Check if a broadcast is set in the url params
        const id = this.id

        //  If id is NOT set, we are done
        if (!id) return (this.mounted = true)

        //  Else a broadcast id is set, load it
        await this.$store.dispatch('broadcastsViewSelectedBroadcastGet', id)

        //  Grab our broadcast from the store
        const broadcast = this.broadcast

        //  Get our total number of contacts this gets sent to
        await this.$store.dispatch('broadcastsViewSelectedBroadcastTotalCount', broadcast)

        //  Grab our broadcast group ids
        const groupIds = broadcast.group_ids

        //  Get our broadcast groups
        if (groupIds && groupIds.length > 0)
            await this.$store.dispatch('broadcastsViewSelectedGroupsGet', groupIds)

        //  Get persons
        const personIds = broadcast.person_ids

        if (personIds && personIds.length > 0)
            this.persons = await this.$store.dispatch('personsWhereIn', personIds)

        //  Get exclude groups
        const excludeGroupids = broadcast.exclude_group_ids

        if (excludeGroupids && excludeGroupids.length > 0)
            this.excludeGroups = await this.$store.dispatch(
                'groupsWhereIn',
                excludeGroupids
            )

        //  Get exclude persons
        const excludePersonIds = broadcast.exclude_person_ids

        if (excludePersonIds && excludePersonIds.length > 0)
            this.excludePersons = await this.$store.dispatch(
                'personsWhereIn',
                excludePersonIds
            )

        //  We finished doing everything we needed to so we are now mounted
        this.mounted = true
    },
    computed: {
        ...mapGetters({
            broadcast: 'broadcastsViewSelectedBroadcast',
            broadcastGroups: 'broadcastsViewSelectedGroups',
            contactsCount: 'broadcastsViewSelectedBroadcastTotalCount',
            failedLastPage: 'broadcastsViewFailedMessagesLastPage',
            failedMessages: 'broadcastsViewFailedMessages',
            failedPaginating: 'broadcastsViewFailedMessagesPaginating',
            failedParams: 'broadcastsViewFailedMessagesParams',
            lastPage: 'broadcastsViewBroadcastsLastPage',
            messagesFailedTotal: 'broadcastsViewFailedMessagesTotal',
            messagesSendingTotal: 'broadcastsViewTotalSendingMessages',
            messagesSentTotal: 'broadcastsViewSentMessagesTotal',
            paginating: 'broadcastsViewPaginating',
            scrollPositionLeft: 'scrollPositionLeft',
            sentLastPage: 'broadcastsViewSentMessagesLastPage',
            sentMessages: 'broadcastsViewSentMessages',
            sentPaginating: 'broadcastsViewSentMessagesPaginating',
            sentParams: 'broadcastsViewSentMessagesParams',
            totalMessages: 'broadcastsViewTotalMessages'
        }),
        analyticsTabTiles(): object {
            const reporting = {
                top: [
                    {
                        text: 'Credits Used',
                        rate: this.creditCount * this.messagesSentTotal
                    },
                    {
                        text: 'Delivery',
                        rate: `${this.successRate}%`
                    },
                    {
                        text: 'Failure',
                        rate: `${this.failureRate}%`
                    }
                ],
                bottom: [
                    {
                        bottomText: 'Messages Sent',
                        rate: this.totalMessages,
                        callback: () => this.$refs.broadcastTabs.tabChange(2)
                    },
                    {
                        bottomText: 'Contacts Reached',
                        rate: this.totalMessages - this.messagesFailedTotal,
                        callback: () => this.$refs.broadcastTabs.tabChange(2)
                    },
                    {
                        bottomText: 'Messages Failed',
                        rate: this.messagesFailedTotal,
                        callback: () => this.$refs.broadcastTabs.tabChange(3)
                    }
                ]
            }

            return reporting
        },
        broadcastsFailedParams: {
            get(): BroadcastParams {
                return this.$store.getters.broadcastsViewFailedMessagesParams
            },
            set(val: BroadcastParams) {
                this.$store.commit('broadcastsViewFailedMessagesParamsSet', val)
            }
        },
        broadcastsSentParams: {
            get(): BroadcastParams {
                return this.$store.getters.broadcastsViewSentMessagesParams
            },
            set(val: BroadcastParams) {
                this.$store.commit('broadcastsViewSentMessagesParamsSet', val)
            }
        },
        //  Determine the credit cost to send the message
        creditCount(): number {
            //  If the message count is greater than 3, we return default 3
            if (this.messageCount > 3) return 3

            //  Else, if the message contains media (ie is MMS), we return default 3
            if (this.broadcast.media) return 3

            //  Else, return the message count (will be less than 3)
            return this.messageCount
        },
        failureRate(): string {
            //  If the broadcast is NOT loaded, return nothing
            if (!this.broadcast) return null

            //  Else, determine if we can calcuate the failure rate
            const isCompleted = this.broadcast.status === 'completed'

            //  If we are unable to calculate the failure rate, return nothing
            if (!isCompleted) return null

            //  Else, calculate the failure rate
            return this.broadcastFailureRate()
        },
        //  Determine the number of message parts to send the current text
        messageCount(): number {
            //  If this broadcast contains media, it is always 3
            if (this.broadcast.media_id) return 3

            //  Grab our broadcast text
            const text = this.broadcast.message

            //  Get our character limit
            const charLimit = this.messageCharLimit(text)

            //  Calculate how many messages to send the text
            const count = Math.ceil(text.length / charLimit)

            //  If the count is greater than zero, return the count
            if (count > 0) return count

            //  Else, return the default 1 (even if no text exists)
            return 1
        },
        //  Determines if we are currently getting messages for this broadcast
        messagesPaginating(): boolean {
            //  Just be simple: if we are getting failed OR sent messages, we are paginating
            return this.sentPaginating || this.failedPaginating
        },
        //
        messageTabTiles(): object[] {
            const reporting: object[] = [
                {
                    text: 'Delivery',
                    rate: `${this.successRate}%`
                },
                {
                    text: 'Failure',
                    rate: `${this.failureRate}%`
                },
                {
                    text: 'Contacts Reached',
                    rate: `${this.totalMessages - this.messagesFailedTotal}`
                }
            ]
            return reporting
        },
        //  Bool determining if the 'Edit' and 'Delete' tools are shown
        showTools(): boolean {
            //  If a broadcast does NOT exist, hide tools
            if (!this.broadcast) return false

            //  If the broadcast is 'completed', hide tools
            if (this.broadcast.status === 'completed') return false

            //  If the broadcast has a schedule, show the tools
            if (this.broadcast.schedule) return true

            //  Else, default to hide tools
            return false
        },
        schedules(): Schedule[] {
            if (!this.broadcast) return null

            //  If the broadcast has a schedule return it
            if (this.broadcast.schedule) return [this.broadcast.schedule]

            //  Else, return empty array
            return []
        },
        successRate(): string {
            //  If the broadcast is NOT loaded, return nothing
            if (!this.broadcast) return null

            //  Else, determine if we can calcuate the success rate
            const isCompleted = this.broadcast.status === 'completed'

            //  If we are unable to calculate the success rate, return nothing
            if (!isCompleted) return null

            //  Else, calculate the success rate
            return this.broadcastSuccessRate()
        }
    },
    methods: {
        broadcastFailureRate(): string {
            //  Get lists totals
            const failures = this.messagesFailedTotal
            const total = this.totalMessages

            //  If both values are zero, return zero
            if (total === 0 && failures === 0) return '0'

            //  Calculate the failure rate
            const failure = failures / total
            const failureRate = (failure * 100).toFixed(0)

            //  Return the failure rate
            return failureRate
        },
        broadcastSuccessRate(): string {
            //  Get lists totals
            const total = this.totalMessages
            const delivered = this.messagesSentTotal

            //  If both values are zero, return zero
            if (delivered === 0 && total === 0) return '0'

            //  Calculate the success rate
            const success = delivered / total
            const successRate = (success * 100).toFixed(0)

            //  Return the success rate
            return successRate
        },
        //  Navigate to the group
        goToGroup(group: Group) {
            //  Go to the group
            this.$router.push(`/groups/${group.id}`)
        },
        /**
         * Message tile related functions START
         */
        messageActions(msg: Message): IListAction {
            //  Grab our channel id from our message
            const channel_id = msg.channel_id

            //  Create our singular button
            const btn: Button = {
                icon: 'mdi-inbox',
                tooltip: 'Go to Inbox',
                color: 'primary',
                callback: () => this.$router.push(`/inbox?channel=${channel_id}`)
            }

            //  Create our IListAction
            const action: IListAction = {
                type: IListActionType.button,
                button: btn
            }

            //  Return our newly created action
            return action
        },
        messageCallback(msg: Message): void {
            //  Grab our status
            const status = msg.status

            //  Route based on status
            if (status === 'failed') this.popFailedMessage(msg)
            else this.popStatusMessage(msg)
        },
        messageColumns(msg: Message): IListTileColumn[] {
            //  Create our first column
            const one: IListTileColumn = {
                line1: this.$options.filters.personFullNameOrEmail(msg.recipient),
                line2: this.$options.filters.personDefaultPhone(msg.recipient)
            }

            //  Create our second column
            const two: IListTileColumn = {
                centered: true,
                line1: this.$options.filters.messageStatus(msg)
            }

            //  Create our columns container
            const columns: IListTileColumn[] = [one, two]

            //  Return our columns
            return columns
        },
        messageIcon(): IListIcon {
            //  Our icon
            const icon = 'mdi-account'

            //  Create our IListIcon object
            const listIcon: IListIcon = {
                type: IListIconType.icon,
                content: icon,
                color: 'primary'
            }

            //  Return our IListIcon object
            return listIcon
        },
        messageTile(): IListTile {
            return {
                actionContent: (m: Message): IListAction => this.messageActions(m),
                leftIcon: (): IListIcon => this.messageIcon(),
                leftFooter: (m: Message): string =>
                    this.$options.filters.personType(m.recipient),
                callback: (m: Message): void => this.messageCallback(m),
                columns: (m: Message): IListTileColumn[] => this.messageColumns(m)
            }
        },
        // Occurs when failed filter is applied
        onFailedFilterChanged(filter: BroadcastFailedFilterParams): void {
            // If 'all' filter is applied, set filterApplied to false
            // because we are no longer filtering
            if (filter.value == 'all') this.filterApplied = false
            // Else, set filterApplied to true
            else this.filterApplied = true

            //  Grab the key and value from our filter
            const key = filter.key
            const value = filter.value

            //  Get our current params
            const params = this.broadcastsFailedParams

            //  Check if we currently have this filter applied
            const isSame = params[key] === value

            //  If it is the same, don't do anything
            if (isSame) return

            //  Else, apply this to our params
            params[key] = value

            //  Also set page to 1 since we changed filter
            params.page = 1

            //  (our computed setter will apply this in the store)
            this.broadcastsFailedParams = params

            //  The filter was changed so we should paginate the new filter
            this.$store.dispatch('broadcastsViewFailedMessagesGet', this.broadcast.id)
        },
        // Occurs when sent filter is applied
        onSentFilterChanged(filter: BroadcastSentFilterParams): void {
            // If 'all' filter is applied, set filterApplied to false
            // because we are no longer filtering
            if (filter.value == 'all') this.filterApplied = false
            // Else, set filterApplied to true
            else this.filterApplied = true

            //  Grab the key and value from our filter
            const key = filter.key
            const value = filter.value

            //  Get our current params
            const params = this.broadcastsSentParams

            //  Check if we currently have this filter applied
            const isSame = params[key] === value

            //  If it is the same, don't do anything
            if (isSame) return

            //  Else, apply this to our params
            params[key] = value

            //  Also set page to 1 since we changed filter
            params.page = 1

            //  (our computed setter will apply this in the store)
            this.broadcastsSentParams = params

            //  The filter was changed so we should paginate the new filter
            this.$store.dispatch('broadcastsViewSentMessagesGet', this.broadcast.id)
        },
        //  Paginates our list of failed or sent messages depending on which is the active index
        paginateCurrentList() {
            //  Grab our current broadcast
            const broadcast = this.broadcast

            //  If no broadcast, return
            if (!broadcast) return

            //  Else grab our broadcast id
            const broadcastId = broadcast.id

            //  Grab our active index
            const idx = this.$refs.broadcastTabs.activeIndex

            //  Get current pagination params based on index
            const params = idx === 1 ? this.sentParams : this.failedParams

            //  Determine the next page
            const nextPage = params.page + 1

            //  Get our last page based on index
            const lastPage = idx === 1 ? this.sentLastPage : this.failedLastPage

            //  Determine if we should paginate
            const shouldPaginate = nextPage <= lastPage

            //  If we should NOT paginate, do nothing
            if (!shouldPaginate) return

            //  Our paramsSet is the commit method we use for our params
            const paramsSet =
                idx === 1
                    ? 'broadcastsViewSentMessagesParamsSet'
                    : 'broadcastsViewFailedMessagesParamsSet'

            //  Our dispatch method is the method we use for paginating our list
            const dispatchMethod =
                idx === 1
                    ? 'broadcastsViewSentMessagesGet'
                    : 'broadcastsViewFailedMessagesGet'

            //  Else, update our pagination params
            params.page = nextPage
            this.$store.commit(paramsSet, params)

            //  Paginate the next page
            this.$store.dispatch(dispatchMethod, broadcastId)
        },
        /**
         *  END message tile related functions
         */
        placeholder(type: string): IListPlaceholder {
            //  Grab our broadcast status
            const status = this.broadcast.status

            //  Get our text based on status
            const text =
                {
                    scheduled: `This broadcast is scheduled.  Information here will update when the broadcast is sent.`,
                    sending: `This broadcast is in progress.  Information here will update when the broadcast is completed`
                }[status] || null

            //  If text is NOT null, return it
            if (text) return { content: text }

            //  Else, text depends on the type we passed in and if fitler is applied
            const typeText = {
                sent: `${
                    this.filterApplied
                        ? 'No messages apply to this filter'
                        : 'No messages were sent during the Broacast'
                }`,
                failed: 'No failures were reported during the Broadcast'
            }[type]

            //  Return our text
            return { content: typeText }
        },
        popSendingHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Sending Messages',
                text: '"Sending" messages mean that MessageDesk never received confirmation of delivery or that the message is still trying to reach your contacts phone. This can happen if your contact is using an outdated cellular device or was experiencing bad network connection at the time of sending. Occasionally, we may not receive a delivery receipt at all depending on the carrier.',
                icon: 'bi-chat-square-dots',
                color: 'primary'
            })
        },
        tabChange(tab: number): void {
            switch (tab) {
                case 0:
                    this.onFailedFilterChanged({ key: 'failedType', value: null })
                    this.onSentFilterChanged({ key: 'sentType', value: null })
                    break
                case 3:
                    this.onFailedFilterChanged(this.failedType.selected)
                    break
                default:
            }
        }
    },
    watch: {
        id(val: number): void {
            //  Set our broadcast to this id
            this.$store.dispatch('broadcastsViewSelectedBroadcastGet', val)
        },
        broadcast(broadcast: Broadcast): void {
            //  If broadcast is set to null, then reset our messages
            if (!broadcast) return this.$store.commit('broadcastsViewMessagesReset')

            //  Else, we should get the failed and sent messages and total messages
            this.$store.dispatch('broadcastsViewTotalMessagesCount', broadcast.id)
            this.$store.dispatch('broadcastsViewFailedMessagesGet', broadcast.id)
            this.$store.dispatch('broadcastsViewSentMessagesGet', broadcast.id)
            this.$store.dispatch('broadcastsViewTotalSendingMessagesCount', broadcast.id)
        },
        scrollPositionLeft(position: ScrollPosition): void {
            //  If we are paginating, do nothing
            if (this.messagesPaginating) return

            //  If the scroll is NOT at the bottom, do nothing
            if (!position.bottom) return

            //  Grab our tab panel active index
            const index = this.$refs.broadcastTabs.activeIndex

            //  If the index is NOT 2 or 3, do nothing
            if (index !== 2 && index !== 3) return

            //  Else, paginate our list
            this.paginateCurrentList()
        }
    }
})
